import React from 'react'
import AgTechTourHelpButton from '@agtech/web/components/App/Tour/AgTechTourHelpButton';
import { SaleContactCreditViewDialogTourConfig } from './SaleContactCreditViewDialogTourConfig';
import { AgTechButtonProps, AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons';
import AgTechViewDialog from '@agtech/web/components/Portals/Dialogs/AgTechViewDialog';
import SaleContactCreditsTabPage from '../../pages/SaleContactCreditsTabPage';
import { useAgTechQuery } from '@agtech/core/data/queries/AgTechDataQueries';
import { getContactFullName } from '@agtech/data/contacts/ContactData';
import { ContactDataGetContactDetailsQuery } from '@agtech/data/contacts/ContactDataQueries';

export type ContactCreditsViewDialogProps = {
    contactId: number
}

const ContactCreditViewDialog = (props: ContactCreditsViewDialogProps) => {
    const dialogQuery = useAgTechQuery({
        query: ContactDataGetContactDetailsQuery,
        queryContext: { contactId: props.contactId }
    });

    return (
        <AgTechViewDialog
            data={{
                query: dialogQuery
            }}
            structure={{
                header: data => ({
                    header: 'Credits - ' + getContactFullName(data.contact),
                    detail: "Below is an overview of current credits for the above contact",
                    settings: {
                        content: {
                            body: () => <AgTechTourHelpButton tourConfig={SaleContactCreditViewDialogTourConfig} />
                        }
                    }
                }),
                width: '800px',
            }}
        >
            {() => {
                return (
                    <div id='contact-credits-view' className='stretched p-body flex'>
                        <SaleContactCreditsTabPage contactId={props.contactId} />
                    </div>
                )
            }}
        </AgTechViewDialog>
    )
}

ContactCreditViewDialog.Button = (props: ContactCreditsViewDialogProps & AgTechButtonProps) => {
    let buttonProps: AgTechButtonProps = {
        ...props,
        action: e => e.dialogs.openDialog({
            dialog: () => <ContactCreditViewDialog {...props} />
        })
    };

    buttonProps.text = buttonProps.text ? buttonProps.text : 'View credits';
    buttonProps.icon = buttonProps.icon ? buttonProps.text : 'fas fa-eye';

    return <AgTechButton {...buttonProps} />
}

export default ContactCreditViewDialog;